// extracted by mini-css-extract-plugin
export default {"flag":"styles_flag__0SYfs"};